import type { MfgMaterial, MfgMaterialUse } from "@/lib/manufacturing/types";
import { MaterialSearchableMultiSelect } from "./MaterialSearchableMultiSelect";
import { ManufacturingMarkMaterialMissingControl } from "./ManufacturingMarkMaterialMissingControl";

/** Add catalog members + Mark-missing placeholder for a part use. */
export function ManufacturingMaterialUseAddMembersBlock({
  selectedUse,
  plantMaterials,
  memberMaterialIds,
  disabled,
  onAddMembers,
  onError,
}: {
  selectedUse: MfgMaterialUse | null;
  plantMaterials: readonly MfgMaterial[];
  memberMaterialIds: ReadonlySet<string>;
  disabled: boolean;
  onAddMembers: (materialIds: ReadonlyArray<string>) => void;
  onError?: (message: string | null) => void;
}) {
  return (
    <div className="mt-3">
      <p className="mb-1 text-sm font-medium text-gray-700 dark:text-zinc-300">Add members</p>
      <p className="mb-1 text-[11px] text-gray-500 dark:text-zinc-400">
        Search, check one or more (or select all filtered), then add.
      </p>
      <MaterialSearchableMultiSelect
        materials={plantMaterials.filter((m) => !memberMaterialIds.has(m.id))}
        disabled={disabled}
        onAdd={(picked) => onAddMembers(picked.map((m) => m.id))}
        placeholder="Search plant materials — commas AND (e.g. hinge, brass)…"
      />
      {selectedUse ? (
        <div className="mt-2">
          <ManufacturingMarkMaterialMissingControl
            ownerKind="material_use"
            materialUseId={selectedUse.id}
            disabled={disabled}
            onError={(msg) => onError?.(msg)}
            onCreated={() => onError?.(null)}
          />
          <p className="mt-1 text-[11px] text-gray-500 dark:text-zinc-400">
            Can&apos;t find a catalog SKU? Mark missing and match it later in Inventory → Missing.
          </p>
        </div>
      ) : null}
    </div>
  );
}
